!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.storeblocks=t():e.storeblocks=t()}(self,(()=>(()=>{"use strict";var e={279:(e,t,o)=>{o.d(t,{Content:()=>c,DialogBase:()=>l,FloatingOverlay:()=>i,Footer:()=>d,Heading:()=>s});var n=o(663);const r=require("styled-components");var a=o.n(r);const i=a()(n.FloatingOverlay)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  background-color: var(--color-scrim);

  @media (prefers-reduced-motion) {
    animation: none !important;
    transition: none !important;
  }
`,l=a()("div").attrs({className:"dialog"})`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  opacity: 1;

  display: flex;
  flex-direction: column;

  box-sizing: border-box;
  max-height: calc(100vh - 80px);
  max-width: 672px;
  width: 100%;
  padding: 32px;

  font-family: 'Open Sans', sans-serif;
  background: var(--color-background);

  z-index: 1;
  box-shadow: var(--elevation-aboveScrim);

  @media only screen and (max-width: 720px) {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    transform: none !important; // !important is needed to overwrite framer-motion inline-style.

    max-width: unset;
    max-height: unset;
  }
`,s=a().div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 16px;
`,c=a().div`
  overflow: auto;

  line-height: 24px;
  margin-bottom: 16px;
`,d=a().div`
  & > button {
    margin-right: 8px;
    margin-top: 16px;
  }
`},663:e=>{e.exports=require("@floating-ui/react")}},t={};function o(n){var r=t[n];if(void 0!==r)return r.exports;var a=t[n]={exports:{}};return e[n](a,a.exports,o),a.exports}o.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return o.d(t,{a:t}),t},o.d=(e,t)=>{for(var n in t)o.o(t,n)&&!o.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},o.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),o.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var n={};return(()=>{o.r(n),o.d(n,{default:()=>s});const e=require("@storeblocks/button");var t=o.n(e),r=o(663);const a=require("react");var i=o.n(a),l=o(279);const s=function({open:e,onConfirm:o,onClose:n,confirmButtonLabel:s,cancelButtonLabel:c,loadingConfirm:d,heading:m,trigger:p,disableAnimation:u,children:g}){const f=Boolean(c&&!d),{reference:b,floating:x,context:y}=(0,r.useFloating)({open:e,onOpenChange:n}),{isMounted:v,styles:h}=(0,r.useTransitionStyles)(y,{duration:u?0:100}),O=(0,r.useId)(),k=`${O}-label`,E=`${O}-description`,{getReferenceProps:j,getFloatingProps:F}=(0,r.useInteractions)([(0,r.useClick)(y),(0,r.useRole)(y),(0,r.useDismiss)(y,{enabled:f})]),w=(0,a.useMemo)((()=>(0,a.isValidElement)(p)&&(0,a.cloneElement)(p,j(Object.assign({ref:b},p.props)))),[p,b,j]);return i().createElement(i().Fragment,null,w,i().createElement(r.FloatingPortal,null,v&&i().createElement(l.FloatingOverlay,{lockScroll:!0,style:Object.assign({},h)},i().createElement(r.FloatingFocusManager,{context:y},i().createElement(l.DialogBase,Object.assign({},F({ref:x,className:"dialog","aria-labelledby":k,"aria-describedby":E})),i().createElement(l.Heading,{labelId:k},m),i().createElement(l.Content,null,g),i().createElement(l.Footer,null,i().createElement(t(),{key:"dialog-confirm",as:"button",variant:"contained",onClick:o,loading:d},s),c&&i().createElement(t(),{key:"dialog-cancel",as:"button",variant:"text",mr:"8px",onClick:n,disabled:!f},c)))))))}})(),n})()));
//# sourceMappingURL=index.js.map